import { useEffect, useState } from 'react';
import { fetchAuthConfig } from './api.js';

/** Server capabilities that shape the UI (§9: AI drafting needs a Gemini key). Loaded once per session. */
let ai = false;
let extract = false;
let ask = false;
let telegramBot: string | null = null;
let loaded: Promise<void> | null = null;
const listeners = new Set<() => void>();

export function loadFeatures(): Promise<void> {
  loaded ??= fetchAuthConfig()
    .then((c) => {
      ai = c.ai;
      extract = c.extract;
      ask = c.ask;
      telegramBot = c.telegramBot;
      for (const l of listeners) l();
    })
    .catch(() => undefined);
  return loaded;
}

export function useTelegramBot(): string | null {
  const [v, setV] = useState(telegramBot);
  useEffect(() => {
    const l = () => setV(telegramBot);
    listeners.add(l);
    void loadFeatures().then(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return v;
}

export function useExtractEnabled(): boolean {
  const [v, setV] = useState(extract);
  useEffect(() => {
    const l = () => setV(extract);
    listeners.add(l);
    void loadFeatures().then(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return v;
}

export function useAskEnabled(): boolean {
  const [v, setV] = useState(ask);
  useEffect(() => {
    const l = () => setV(ask);
    listeners.add(l);
    void loadFeatures().then(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return v;
}

export function useAiEnabled(): boolean {
  const [v, setV] = useState(ai);
  useEffect(() => {
    const l = () => setV(ai);
    listeners.add(l);
    void loadFeatures().then(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  return v;
}
